import { render } from "./PaginationFirst.vue?vue&type=template&id=7757f6d2&ts=true"
import script from "./PaginationFirst.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationFirst.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationFirst.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7757f6d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7757f6d2', __exports__)) {
    api.reload('7757f6d2', __exports__)
  }
  
  module.hot.accept("./PaginationFirst.vue?vue&type=template&id=7757f6d2&ts=true", () => {
    api.rerender('7757f6d2', render)
  })

}


export default __exports__